import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

import { firebaseAppCredentials } from '../config/firebase';

// ─────────────────────────────────────────────────────────────────────────────
// A-3.a (auditoría, ronda 71) — Bootstrap de Firebase para todo el BO.
//
// firebase ^10.14 en modo COMPAT: la MISMA API v8 que usa todo el código del
// BO, sobre internals modernos. Compat se eligió a propósito: quince archivos
// usan la API v8 directo (hooks de realtime, acciones de transacciones,
// dossier, etc.); reescribirlos a modular en una ronda sin runtime era el
// riesgo real. Con compat cambian una línea de import cada uno.
//
// Por qué 10.14 y no 9.23 (corrección al diseño, verificada en ronda 71): el
// advisory que motivó A-3.a — GHSA-3wf4-68gx-mph8, _authTokenSyncURL
// apuntable a un servidor ajeno — tiene rango <10.9.0: la 9.x seguía ADENTRO.
// Y el miedo de que webpack 4 no tragara la v10 resultó infundado: el build
// de CRA compila 10.14.1 limpio (verificado empíricamente acá). npm audit
// post-migración: firebase sin advisories DIRECTOS; lo que queda flaggeado en
// el árbol (@grpc/protobufjs vía Firestore) es la ruta NODE, que webpack no
// bundlea — el artefacto del navegador tiene CERO ocurrencias de
// grpc/protobuf y usa webchannel (verificado sobre build/). La modularización
// tree-shaken queda para la modernización completa (Opción 2), si llega.
//
// Antes la app default la inicializaba react-admin-firebase adentro de
// createDataProvider; con ese paquete afuera, la inicialización vive ACÁ y es
// idempotente. data.ts importa este módulo, y App.tsx importa data.ts
// temprano: la app existe antes que cualquier uso. La app secundaria
// 'createUserOnly' (crear usuarios sin pisar la sesión del admin) sigue en
// auth.ts, como siempre.
// ─────────────────────────────────────────────────────────────────────────────

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseAppCredentials);
}

export { firebase };
export const db = firebase.firestore();
export const auth = firebase.auth();
